module.exports = __webpack_public_path__ + "img/finding-workforce.d39e3b78.svg";